import { jsx as _jsx } from "react/jsx-runtime";
import { DataTableColumnHeader } from "../DataTableColumnHeader";
/**
 * Helper function to create a column header with automatic onAddFilter extraction from context
 * This reduces code duplication across column definitions
 */ /** The title each header made here carries, for the column menu's names (Malte, 30.10.2026). */ const HEADER_TITLES = new WeakMap();
/** The title of a header made by `createColumnHeader`, or a plain string header; else nothing. */ export function headerTitleOf(header) {
    if (typeof header === "string") return header;
    return typeof header === "function" ? HEADER_TITLES.get(header) : undefined;
}
export function createColumnHeader(title) {
    const HeaderComponent = ({ column, ...context })=>/*#__PURE__*/ _jsx(DataTableColumnHeader, {
            column: column,
            title: title,
            onAddFilter: "onAddFilter" in context ? context.onAddFilter : undefined,
            onUpdateFilter: "onUpdateFilter" in context ? context.onUpdateFilter : undefined,
            externallyFiltered: "externallyFiltered" in context ? Boolean(context.externallyFiltered) : false,
            sortedColumns: "sortedColumns" in context ? Number(context.sortedColumns) : 0
        });
    HeaderComponent.displayName = `ColumnHeader_${title.replace(/\s+/g, "")}`;
    HEADER_TITLES.set(HeaderComponent, title);
    return HeaderComponent;
}

//# sourceMappingURL=column-header.js.map